import { TypographyV3 } from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';
import type { RichTranslationValues } from 'next-intl';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

import RichText from '@/app/components/RichText';

export interface TermProps {
  readonly index: string;
  readonly term?: MessageKey;
  readonly content: MessageKey;
  readonly values?: RichTranslationValues;
  readonly isDefinition?: boolean;
}

const Term = ({ index, term, content, values, isDefinition }: TermProps) => {
  const t = useTranslations();
  return (
    <TypographyV3
      className={cx('relative pl-14', {
        'my-0': isDefinition,
      })}
    >
      <span className="absolute left-0">{index}.</span>
      {term ? (
        <>
          <u>{t(term)}</u>
          {`. `}
        </>
      ) : null}
      <RichText messageKey={content} tValues={values} />
    </TypographyV3>
  );
};

export default Term;
